var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{attrs:{"title":_vm.info.page_title,"url":"/"}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.page_content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }